import React, {useState, useEffect} from "react";
import { Link } from "react-router-dom";
import moment from "moment";
//import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import "./../../Public/css/bootstrap.min.css";
import "./../../Public/css/tabler-icons.css";
import "./../../Public/css/fontawesome.min.css";
import "./../../Public/css/all.min.css";
import "./../../Public/css/style.css";

import {DashboardAPI, getTeamsAPI, DashboardTeamFilterAPI, getTeamCampaignListAPI, getFilterCallerListAPI, DashboardFilterAPI} from "./../../API/Sales/DashboardAPI";
import Sidebar from "./Common/Sidebar";
import Header from "./Common/Header";
import Loader from "./../Loader";
//import PieChart from "../../utils/Charts/PieChart";


const Dashboard = () =>{

	//const [campaignslist, setCampaignsList] = useState([]);
	//const [teamcount, setTeamCount] = useState(0);
	//const [campaigncount, setCampaignCount] = useState(0);
	//const [leadcount, setLeadCount] = useState(0);
	//const [convertedleadcount, setConvertedLeadCount] = useState(0);
	//const [loading, setLoading] = useState(false);
	//const [showleadperformchart, setShowLeadPerformChart] = useState(true);
	//const [leadperformseries, setLeadPerformSeries] = useState([]);
	//const [leadperformoptions, setLeadPerformOptions] = useState([]);
	//const [filtercampaignid, setFilterCampaignID] = useState(0);
	const [freshleadcount, setFreshLeadCount] = useState(0);
	const [pendingfollowupcount, setPendingFollowupCount] = useState(0);
	const [todayfollowupcount, setTodayFollowupCount] = useState(0);
	const [warmcount, setWarmCount] = useState(0);
	const [isstatreload, setIsStatReload] = useState(false);
	//const [notifications, setNotifications] = useState([]);
	const [loggedname, setLoggedName] = useState("");	
	const [teams, setTeams] = useState([]);
	const [campaigns, setCampaigns] = useState([]);
	const [callers, setCallers] = useState([]);
	const [filterteam, setFilterTeam] = useState("");
	const [filtercampaign, setFilterCampaign] = useState("");
	const [filtercaller, setFilterCaller] = useState("");
	const [filterstartdate, setFilterStartDate] = useState("");
	const [filterenddate, setFilterEndDate] = useState("");


	const current = moment();

	useEffect(()=>{

		const userinfo = localStorage.getItem("userinfo");

        if(userinfo !== "" && userinfo !== null && userinfo !== undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            
        }

		getTeamsAPI(setTeams);

	}, [])

	useEffect(() =>{
		console.log('Sales dahboard');

		//const token = localStorage.getItem("cpmstoken");

		//if (!token) return;

		DashboardAPI(setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setIsStatReload, setWarmCount);

		//DashboardAPI(setCampaignsList, setTeamCount, setCampaignCount, setLeadCount, setConvertedLeadCount, setLoading);
		//LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, "");

	}, []);

	/*const handleSelectCampaign = (e) =>{
		
		const filterparams = new URLSearchParams();

        if(e.target.value > 0)
        {
            filterparams.append('filtercampaignid', e.target.value);

			LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, filterparams);
        }
		else
		{
			LeadPerformanceReportAPI(setLeadPerformSeries, setLeadPerformOptions, setShowLeadPerformChart, "");
		}
		
	}*/

	const handleReloadStats = () =>{

		setIsStatReload(true);

		DashboardAPI(setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setIsStatReload, setWarmCount);
	}

	const handleFilterTeam = (e) =>{
		setFilterTeam(e.target.value);

		getTeamCampaignListAPI(e.target.value, setCampaigns);
	}

	const handleFilterCampaign = (e) =>{
		setFilterCampaign(e.target.value);

		getFilterCallerListAPI(e.target.value, setCallers);
	}

	const handleFilterCaller = (e) =>{
		setFilterCaller(e.target.value);
	}

	const handleStartDate = (e) =>{
		setFilterStartDate(e.target.value);
	}

	const handleEndDate = (e) =>{
		setFilterEndDate(e.target.value);
	}

	/*const handleStatsFilter = () =>{
		
		const params = { "teamid": filterteam };

		DashboardTeamFilterAPI(setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, params);
	}*/

	const handleFilterDashboardCounts = () =>{

		const filterparams = new URLSearchParams();

        if(filterteam)
        {
            filterparams.append('team_id', filterteam);
        }

		if(filtercampaign)
        {
            filterparams.append('campaign_id', filtercampaign);
        }

        if(filtercaller)
        {
            filterparams.append('caller_id', filtercaller);
        }

        if(filterstartdate)
        {
            filterparams.append('start_date', filterstartdate);
        }

		if(filterenddate)
        {
            filterparams.append('end_date', filterenddate);
        }

		DashboardFilterAPI(filterparams, setFreshLeadCount, setPendingFollowupCount, setTodayFollowupCount, setWarmCount);
	}

	const handleFilterReset = () =>{
		setFilterTeam("");
		setFilterCampaign("");
		setFilterCaller("");
		setFilterStartDate("");
		setFilterEndDate("");

		handleReloadStats();
	}


    return(
	<div className="main-wrapper">

		<Loader />

		<Header />

		<Sidebar />

		<div className="page-wrapper">
			<div className="content">
				{/*<div className="row">
					<div className="col-md-12">
						<div className="page-header">
							<div className="row align-items-center ">
								<div className="col-md-4">
									<h3 className="page-title">Leads Dashboard</h3>
								</div>
								<div className="col-md-8 float-end ms-auto">
									<div className="d-flex title-head">
										<div className="daterange-picker d-flex align-items-center justify-content-center">
											<div className="form-sort me-2">
												<i className="ti ti-calendar"></i>
												<input type="text" className="form-control  date-range bookingrange" />
											</div>
											<div className="head-icons mb-0">
												<Link to="" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Refresh">
													<i className="ti ti-refresh-dot"></i>
												</Link>
												<Link to="" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-original-title="Collapse" id="collapse-header">
													<i className="ti ti-chevrons-up"></i>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>*/}
				<div class="welcome-wrap mb-4">
					<div class=" d-flex align-items-center justify-content-between flex-wrap">
						<div class="mb-3">
							<h2 class="mb-1 text-white">Sales Manager Dashboard</h2>
							<p class="text-light">As of {current.format('DD MMMM YYYY')} {current.format('hh:mm A')}</p>
						</div>
						<div class="d-flex align-items-center flex-wrap mb-1">
							{/*<a href="company.html" class="btn btn-dark btn-md me-2 mb-2">Companies</a>*/}
							<button type="button" class="btn btn-light btn-md mb-2" onClick={handleReloadStats}>Refresh</button>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-md-12">
						<div className="page-header">
							<div className="row align-items-center ">
								
									
										<div className="col-md-2">
											<select className="form-control" name="teams" value={filterteam} onChange={handleFilterTeam}>
												<option value="">Select Team</option>
												{ teams.map((team) =>(
													<option key={team.id} value={team.id}>{team.name}</option>
													))
												}
											</select>
										</div>
										<div className="col-md-2">
											<select className="form-control" name="campaign" value={filtercampaign} onChange={handleFilterCampaign}>
												<option value="">Select Campaigns</option>
												{campaigns && campaigns.map(campaigndata =>(
												<option key={campaigndata.id} value={campaigndata.id}>{campaigndata.name}</option>		
												))}
											</select>
										</div>

										<div className="col-md-2">
											<select className="form-control" name="caller" value={filtercaller} onChange={handleFilterCaller}>
												<option value="">Select Caller</option>
												{callers.map(callerdata =>(
												<option key={callerdata.id} value={callerdata.id}>{callerdata.name}</option>		
												))}
											</select>
										</div>

										<div className="col-md-2">
											<input type="date" className="form-control" name="startdate" value={filterstartdate} onChange={handleStartDate} />
										</div>
										<div className="col-md-2">
											<input type="date" className="form-control" name="enddate" value={filterenddate} onChange={handleEndDate} />
										</div>

										<div className="col-md-2 d-flex button-filter">
											<button type="button" className="btn btn-info me-2" onClick={handleFilterDashboardCounts}>
												<i className="ti ti-search me-2"></i> Apply
											</button>
											
											<button type="button" className="btn btn-dark" onClick={handleFilterReset}>
												<i className="ti ti-restore me-2"></i>Reset
											</button>
										</div>
									
								
							</div>
						</div>
					</div>
				</div>
				<div class="row">
					<div className="col-md-12">
						<div className="row">
							<div className="col-md-3">
								<div className="card card-border-bottom">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{freshleadcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Fresh Leads</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="card card-border-bottom">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{todayfollowupcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Follow Up for Today</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="card card-border-bottom">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{warmcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Warm Leads</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-3">
								<div className="card card-border-bottom">
									<div className="card-body p-3 d-flex align-items-center mx-auto">                            	
										<div>
											<div className="fs-25 fw-semibold widget-text text-center">{pendingfollowupcount}</div>
											<div className="text-body-secondary fw-semibold widget-heading">Pending Follow Ups</div>
										</div>
									</div>
								</div>
							</div>
							
						</div>
					</div>

				</div>
				<div className="row">
					
				</div>
				
			</div>
		</div>
	</div>
    )
}

export default Dashboard;